import { Merge } from '@graphcommerce/ecommerce-ui'
import { Box, Container } from '@mui/material'
import { ProductPage2Query } from '../../../graphql/ProductPage2.gql'
import { SaleCategoryProductsQuery } from '../../../graphql/SaleCategoryProducts.gql'
import { RowProduct } from '../../GraphCMS'

type ProductType = Merge<
  NonNullable<NonNullable<NonNullable<ProductPage2Query['products']>['items']>[0]>,
  NonNullable<NonNullable<NonNullable<ProductPage2Query['relatedUpsells']>['items']>[0]>
>

type ProductPageExtraProductsProps = {
  product: ProductType
  productsOnSale: NonNullable<
    NonNullable<NonNullable<SaleCategoryProductsQuery['saleCategory']>[0]>['products']
  >['items']
}

export function ProductPageExtraProducts(props: ProductPageExtraProductsProps) {
  const { product, productsOnSale } = props

  const hasUpsellProducts = product?.upsell_products && product?.upsell_products?.length > 0

  const showProductBlock = hasUpsellProducts || (productsOnSale && productsOnSale.length > 0)

  if (!showProductBlock) return null

  const promotionProducts = product?.promotion_products
  const isPromotionProduct = promotionProducts && promotionProducts.length > 0

  return (
    <Box sx={{ bgcolor: 'primary.light', py: { xs: 3, sm: 9 }, mt: { xs: 3, sm: 9 } }}>
      <Container sx={{ px: { xs: 0, sm: 3, md: 4 } }}>
        <RowProduct
          identity='product-page-extra-products'
          productUrlKeys={[]}
          title={
            isPromotionProduct && hasUpsellProducts
              ? 'Anderen kochten ook'
              : 'Producten uit de folder'
          }
          pageLinks={
            isPromotionProduct && hasUpsellProducts
              ? []
              : [{ title: 'Naar de folder', url: '/over-da/folder' }]
          }
          items={
            isPromotionProduct && hasUpsellProducts ? product?.upsell_products : productsOnSale
          }
          variant='Swipeable'
          {...product}
          sx={(theme) => ({
            '& .MuiTypography-h2': {
              pl: { xs: 2, sm: 0 },
            },
            '& .Scroller-root': {
              pl: { xs: theme.spacings.md, sm: 0 },
              scrollPaddingLeft: { xs: theme.spacings.md, sm: 0 },
            },
          })}
        />
      </Container>
    </Box>
  )
}
